import React from 'react';

import DivHonorList from './DivHonorList';

import {getLanguage} from '../../../util/localStorage';

class TabBrHonors extends React.Component {
	
	constructor(props) {
		super(props);
	}

	honorCardBuilder = (fieldHonor, index) => {
		let card = '';
		
		if(fieldHonor.value.honorInfo.value.length > 0) {
			let currentLanguage = getLanguage();
			let info = null;
			for(let inf of fieldHonor.value.honorInfo.value) {
				if( inf.value.language.value == currentLanguage && inf.value.name.value ) {
					info = inf;
					break;
				}
			}
			if( info == null ) {
				for(let inf of fieldHonor.value.honorInfo.value) {
					if( inf.value.name.value ) {
						info = inf;
						break;
					}
				}
			}			
			if( info )
				card = info.value.name.value
		}
		
		if( ! card ) {
			for(let f of fieldHonor.value.images.value) {
				if( f.value.resourceName.value ) {
					card = f.value.resourceName.value;
					break;
				}
			}
		}
		
		return card;
	}
	
	render() {
		let readOnly = this.props.mode == 'special' || this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
	/*
		parentField
		path
		readOnly
		plain
		instance
		ignoreTitle
	*/
		return (
			<DivHonorList path={'/honors'} readOnly={readOnly} plain={plain} instance={instance} ignoreTitle={true} />
		)
	}
}

export default TabBrHonors;